import * as client from '../../services/client';
import { TYPES, PATHS } from '../../common/constants';

  export const setActiveTab = (payload) => ({
    type: TYPES.SET_ACTIVE_TAB,
    payload,
  });

  export const setActiveSuiteTab = (payload) => ({
    type: TYPES.SET_ACTIVE_SUITE_TAB,
    payload,
  });

  export const setActiveCommonAreaTab = (payload) => ({
    type: TYPES.SET_ACTIVE_COMMONAREA_TAB,
    payload,
  });
  export const setActiveContactTab = (payload) => ({
    type: TYPES.SET_ACTIVE_CONTACT_TAB,
    payload,
  });
  export const setActiveCatalogTab = (payload) => ({
    type: TYPES.SET_ACTIVE_CATALOG_TAB,
    payload,
  });
  export const clearActiveTab = () => ({
      type: TYPES.CLEAR_ACTIVE_TAB,
  });
  export const clearActiveSuiteTab = () => ({
    type: TYPES.CLEAR_ACTIVE_SUITE_TAB,
  });
  export const clearActiveCommonAreaTab = () => ({
    type: TYPES.CLEAR_ACTIVE_COMMONAREA_TAB,
  });
  export const clearActiveContactTab = () => ({
    type: TYPES.CLEAR_ACTIVE_CONTACT_TAB,
  });
  export const clearActiveCatalogTab = () => ({
    type: TYPES.CLEAR_ACTIVE_CATALOG_TAB,
  });

